import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegExp } from 'src/app/core/config/regex';
import { Performance } from 'src/app/shared/models/domain';
import { Context } from 'src/app/shared/models/context';
import { Message } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { SettingsService } from 'src/app/shared/services/settings.service';
@Component({
  selector: 'app-performance-crud',
  templateUrl: './performance-crud.component.html',
  styleUrls: ['./performance-crud.component.scss']
})
export class PerformanceCrudComponent implements OnInit {
  @Input() performance: Performance;
  @Input() context: Context;
  @Input() performances: Performance[] = [];
  public performanceForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;
  public isLoading: boolean = true;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private commonService: CommonService,
    private settingService: SettingsService,
  ) { }

  ngOnInit(): void {
    this.setPerformance(this.performance);
  }

  public setPerformance(performance?: Performance) {
    if (!performance)
      performance = {
        id: null,
        label: null,
        value: null,
        disabled: false,
        companyId: null,
        companyName: null,
      } as Performance;
    this.performanceForm = this.fb.group({
      id: this.fb.control(performance?.id || null),
      label: this.fb.control(performance.label, [Validators.required, Validators.pattern(RegExp.name)]),
      value: this.fb.control(performance.value, [Validators.required, Validators.pattern(RegExp.numeric)]),
      disabled: this.fb.control(performance.disabled, []),
      companyId: this.fb.control(performance.companyId, []),
      companyName: this.fb.control(performance.companyName, []),
    });
    this.performanceForm.valueChanges.subscribe(value => this.modified = true);
  }

  get p() {
    return this.performanceForm.controls;
  }

  public savePerformance(inProgress?: any) {
    this.submitted = true;
    if (this.performanceForm.valid) {
      const performance: Performance = this.performanceForm.value;
      let isPerformanceName = this.performances.some(m => m.label === performance.label);
      let isPerformanceValue = this.performances.some(m => m.value === performance.value);
      if (isPerformanceName && isPerformanceValue) {
        this.commonService.setToastr(400, `Performances with both name "${performance.label}" and value "${performance.value}" already exists!`);
        return;
      }
      if (isPerformanceName) {
        this.commonService.setToastr(400, `Performances with name "${performance.label}" already exists!`);
        return;
      }
      if (isPerformanceValue) {
        this.commonService.setToastr(400, `Performances with value "${performance.value}" already exists!`);
        return;
      }
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `Performance ${performance.label} has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (performance.id) {
        this.settingService.updatePerformance(performance.id, performance).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.activeModal.close(true);
              this.commonService.setToastr(200, `Performance ${performance.label} has been updated successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, `Cannot update the record. performance '${performance.label}' already exists.`);
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.settingService.createPerformance(performance).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.activeModal.close(true);
              this.commonService.setToastr(200, `performance ${performance.label} has been created successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, `Cannot add the record. performance '${performance.label}' already exists.`);
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
    }
  }
}

